module.exports = __webpack_public_path__ + "media/images/donation/three-hands-fb122d08cfd062b5335b2d5e523fb9fb.svg";